import {
  changeLanguage,
  changeLocation,
  requestLogin,
  requestLoginFailed,
  requestLoginSuccess,
  requestLogout,
  requestLogoutFailed,
  requestLogoutSuccess,
  requestSignup,
  requestSignupFailed,
  requestSignupSuccess,
  verifyNewAccount,
} from '../actions/authActions';
import { handleActions } from 'redux-actions';

const initialState = {
  authenticated: false,
  currentRoute: '',
  errorText: '',
  id: null,
  isFirstLoading: true,
  langCode: 1,
  language: 'ru',
  loading: true,
  token: null, // legacy, temporary need
};

const authHandler = {
  [changeLanguage]: (state, { payload }) => {
    let currentLang;
    let currentLangCode;
    if (payload === 'en') {
      currentLang = 'en';
      currentLangCode = 2;
    } else if (payload === 'ru') {
      currentLang = 'ru';
      currentLangCode = 1;
    } else {
      currentLang = 'ru';
      currentLangCode = 1;
    }
    return { ...state, langCode: currentLangCode, language: currentLang };
  },
  [changeLocation]: (state, { payload }) => {
    return { ...state, currentRoute: payload };
  },
  [requestLogin]: (state, { payload: { email, password } }) => {
    return { ...state, email, loading: true, password };
  },
  [requestLoginFailed]: (state, { payload }) => {
    return { ...state, errorText: payload, isFirstLoading: false, loading: false };
  },
  [requestLoginSuccess]: (state, { payload }) => {
    return { ...state, authenticated: true, id: payload.userId, isFirstLoading: false, loading: false, password: null };
  },
  [requestLogout]: (state, { payload }) => {
    return { ...state, loading: true };
  },
  [requestLogoutFailed]: (state, { message }) => {
    return { ...state, errorText: message, isFirstLoading: false, loading: false };
  },
  [requestLogoutSuccess]: (state, { payload }) => {
    return { ...initialState, isFirstLoading: false, loading: false };
  },
  [requestSignup]: (state, { payload: { email, password } }) => {
    return { ...state, email, loading: true, password };
  },
  [requestSignupFailed]: (state, { message }) => {
    return { ...state, errorText: message, loading: false };
  },
  [requestSignupSuccess]: (state, { payload }) => {
    return { ...state, loading: false, password: null };
  },
  [verifyNewAccount]: (state, { payload }) => {
    return { ...state };
  },
};

const authReducer = handleActions(authHandler, initialState);

export default authReducer;
